/* eslint-disable node/no-unsupported-features/es-syntax */
import { MAILING_ROUTE_NAMES } from "@/shared";

export const MAILING_ROUTES = [
    {
        name: MAILING_ROUTE_NAMES.LIST,
        path: "/mailing",
        meta: {
            title: "Рассылки",
        },
        component: () => import("../ui/MailingsList.vue"),
    },
    {
        name: MAILING_ROUTE_NAMES.CREATE,
        path: "/mailing/add",
        meta: {
            title: "Новая рассылка",
        },
        component: () => import("../ui/MailingEdit.vue"),
    },
    {
        name: MAILING_ROUTE_NAMES.ONBOARDING,
        path: "/mailing/onboarding",
        meta: {
            title: "Онбординг-цепочка",
        },
        component: () => import("../ui/MailingOnboarding.vue"),
    },
    {
        name: MAILING_ROUTE_NAMES.COHORTS,
        path: "/mailing/cohorts",
        meta: {
            title: "Конструктор когорт",
        },
        component: () => import("../ui/MailingCohorts.vue"),
    },
    {
        name: MAILING_ROUTE_NAMES.STATS,
        path: "/mailing/:id/stats",
        meta: {
            title: "Статистика рассылки",
        },
        component: () => import("../ui/MailingStats.vue"),
        props: true,
    },
    {
        name: MAILING_ROUTE_NAMES.EDIT,
        path: "/mailing/:id",
        meta: {
            title: "Рассылка",
        },
        component: () => import("../ui/MailingEdit.vue"),
        props: true,
    },
];
